export class MfaSessionExpiredError extends Error {
    constructor(message: string) {
        super(message)
        this.name = 'MfaSessionExpiredError'
    }
}
